angular.module('impactx.login')
    .controller('CopyCCUserDialogController', ['LoginService', 'dataGen', 'cookieService', '$scope', 'themeFactory', CopyCCUserDialogController]);

function CopyCCUserDialogController(LoginService, dataGen, cookieService, $scope, themeFactory) {
    cookieService.removeCookie("loginPage");
    $scope.theme = themeFactory.getTheme();
    var self = this;

    this.logout = function () {
        LoginService.logout();
    };

    this.save = function () {
        dataGen.postAsForm({}, {data: $scope.data}, "/user/copycc/save").then(function (data) {
            LoginService.closeDialogAndNavigateToLogin();
            ToastService.openStandardToast(data.trns.savesuccess);
        });
    };

    dataGen.getData($scope, {}, "/user/copycc/view");
}

